import { render, staticRenderFns } from "./Unfound.vue?vue&type=template&id=2b50220b&scoped=true&"
import script from "./Unfound.vue?vue&type=script&lang=js&"
export * from "./Unfound.vue?vue&type=script&lang=js&"
import style0 from "./Unfound.vue?vue&type=style&index=0&id=2b50220b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50220b",
  null
  
)

export default component.exports